import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BordPhoto from '../NudosComponents/BordPhoto/BordPhoto';
import { getNudosData } from '../../utils/getNudosData';
import { NudosHoverText } from '../NudosComponents';
import useAccountState from '../../state/account.state';
import { getUserAdditionalDataById } from '../../services/user.service';
import { displayErrorNotification } from '../../utils/displayNudosStandardNotifications';
import { CALENDLY_LINK_TYPE_ID } from '../../types/configuration.types';
import NotificationBell from '../NotificationBell/NotificationBell';
import './UserProfileSummary.scss';

const UserProfileSummary: React.FC = () => {
  const { userStateData, setUserStateData, firstDataLoad, setFirstDataLoad } = useAccountState();
  const userData = getNudosData()?.userData;
  const location = useLocation();
  const history = useHistory();

  const [loadingAdditionalData, setLoadingAdditionalData] = useState<boolean>(false);

  const hasCompleteInformation = !!(
    userStateData.firstName &&
    userStateData.lastName &&
    userData?.email &&
    userData?.dataPhone?.phone &&
    userStateData.profilePhoto
  );

  const userNameText = hasCompleteInformation
    ? `${userStateData.firstName} ${userStateData.lastName}`
    : 'Completa tu información';
  const userPhoto = hasCompleteInformation ? userStateData.profilePhoto : undefined;

  const isAccountPage = location.pathname.includes('/account');

  const handleLinkClick = () => {
    if (isAccountPage) return;
    history.push('/account');
  };

  const getUserAdditionalData = async () => {
    if (!userData?.id) return;
    setLoadingAdditionalData(true);
    try {
      const additionalData = await getUserAdditionalDataById(userData?.id);
      const calendlyLinkValue = additionalData?.find(
        data => data.additionalDataTypeId === CALENDLY_LINK_TYPE_ID
      )?.value;
      setUserStateData({ calendarLink: calendlyLinkValue || '' });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingAdditionalData(false);
      setFirstDataLoad(true);
    }
  };

  useEffect(() => {
    setUserStateData({
      firstName: userData?.firstName || '',
      lastName: userData?.lastName || '',
      profilePhoto: userData?.photoProfile || ''
    });
  }, []);

  useEffect(() => {
    if (!firstDataLoad) {
      getUserAdditionalData();
    }
  }, [firstDataLoad]);

  if (loadingAdditionalData && !firstDataLoad) return <></>;

  return (
    <div className="userProfileSummary">
      <NotificationBell />
      <BordPhoto
        size="s32"
        variant="circle"
        url={userPhoto}
        avatarProps={{
          variant: 'circularUser',
          standardSize: 32
        }}
      />
      <div className="userData">
        <NudosHoverText
          customClassName={`userName ${!hasCompleteInformation ? 'incomplete' : ''}`}
          text={userNameText}
          onlyIfTruncated
          charactersLimit={24}
        />
        <div className="linkLabel" onClick={handleLinkClick}>
          Cuenta
        </div>
      </div>
    </div>
  );
};

export default UserProfileSummary;
